const alertType = {
  warning: 'warning',
  info: 'info',
  important: 'important'
};

export default alertType;
